import { User } from "./User";
import { ProfileSettings } from "./ProfileSettings";

export class LoginUser {
    email: string;
    userName: string;
    token: string;
    userData?: User;
    settings?: ProfileSettings;

    constructor(
        eMail: string,
        userName: string,
        token: string,
        userData?: User
    ) {
        this.email = eMail;
        this.userName = userName;
        this.token = token;
        this.userData = userData;
    }
    static empty(): LoginUser {
        return {
            email: '',
            userName: '',
            token: localStorage.getItem('token') ?? "",
            userData: User.empty()
        };
    }

}